import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const DiscussionsButton = /*#__PURE__*/ memo((param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("button", {
        className: tailwindMerge("rounded-2 p-1 text-12 font-semibold text-grey-11 hover:bg-grey-5", className),
        "data-testid": "DISCUSSIONS_BUTTON",
        ...restOfProps
    });
});
DiscussionsButton.displayName = "DiscussionsButton";
